<template>
  <div class="result-card" v-if="infoData.status != undefined ">
    <div class="result-card-title">
      {{ infoData.status == '2' ? '反馈建议' : '处理结果' }}
    </div>
    <div class="result-card-info" v-if="infoData.status == '1'">
      {{ infoData.dealResult }}
    </div>
    <div class="result-card-feedback" v-else>
      <z-row>
        <z-col span='5'>平台反馈</z-col>
        <z-col span='19'>{{infoData.feedback}}</z-col>
      </z-row>
      <z-row>
        <z-col span='5'>举报建议</z-col>
        <z-col span='19'>{{suggest.join('')}}</z-col>
      </z-row>
      <z-button icon="https://pic4.zhuanstatic.com/zhuanzh/81589478-67e5-4124-b26b-f153d3df7b81.png" text="上传补充凭证" size="small" @click="goToSupply"></z-button>
    </div>
  </div>
</template>
<script>
import { Row, Col, Button } from '@zz-common/zz-ui';
export default {
  name: 'ResultCard',
  props: {
    infoData: {
      default: () => {}
    }
  },
  components: {
    'z-row': Row,
    'z-col': Col,
    'z-button': Button
  },
  computed: {
    suggest() {
      return this.infoData.suggest || []
    }
  },
  inject: ['id', 'toUid'],
  methods: {
    goToSupply() {
      this.$router.push(
        {
          path: '/ReportSupplementDetial',
          query: {
            beReportedUid: this.toUid,
            reportId: this.id,
            from: 10
          }
        })
    }
  }
}
</script>
<style lang="less" scoped>
 @import 'index.less';
</style>